import Form from "./Form";
import Data from "../../Data";
import {useContext, useEffect, useState} from "react";
import Error from "./Error";
import {useParams} from "react-router-dom";
import AppContext from "../../../../context";

const SiteSettingsLogoUpload = () => {
    const context = useContext(AppContext);

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)

        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await Data.uploadImage({ formData })
            await Data.updateSiteSettings({ name: context.domain.name, primaryColor: context.domain.primaryColor, heading: context.domain.heading, subHeading: context.domain.subHeading, backgroundImage: context.domain.backgroundImage, logo: response.data.data.Location, favicon: context.domain.favicon })
            context.fetchDomain()
        } catch (error) {
            setError(true)
        } finally {
            setLoading(false)
            setFile(null)
        }
    };

    return (
        <Form heading={"Logo"} onSubmit={handleSubmit}>

            {context.domain.logo ?
                <div className={'block w-20 h-20 rounded-full bg-primary'}>
                    <img src={context.domain.logo} alt={context.domain.name} className={"w-full"} />
                </div>
            : null}

            <div className={"flex items-center gap-2 flex-wrap"}>
                <input type="file" disabled={loading} onChange={handleFileChange}/>
                <button type={"submit"} disabled={loading}
                        className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>{loading ? "Uploading..." : "Upload"}</button>
            </div>

            {error ? <Error message={"An error occurred with your image, please try again."}/> : null}
        </Form>
    )
}

export default SiteSettingsLogoUpload;